// apps/client_diy_webapp/src/pages/qualitative-surveys/components/ParticipantCount.js
import React, { useEffect, useState } from "react";
import { RiPencilLine } from "react-icons/ri";
import { useGlobalContext } from "../../../Contexts/GlobalContext";
import SaveBar from "./Savebar";
import { useProjectUpdate } from "../useProjectUpdate";
import { useQuery } from "@tanstack/react-query";
import { getCities, getCountries, getStates, SELECT_STYLE } from "../../../Utlils";
import Spinner from "../../../components/Spinner";
import { EDITABLE_STATUSES } from "../qualitativeUtils";


export default function ParticipantCount({ projectDetails }) {
    const { user } = useGlobalContext();
    const organizationID = user?.organization?._id;
    const projectID = projectDetails?._id;
    const isEditable = EDITABLE_STATUSES?.includes(projectDetails?.status);
    const isFGD = projectDetails?.researchActivity?.moderatedSessionType === "fgd";

    const [numParticipants, setNumParticipants] = useState(
        projectDetails?.participants?.numberOfParticipants ?? ""
    );
    const [perGroup, setPerGroup] = useState(
        projectDetails?.participants?.participantsPerGroup ?? ""
    );
    const [countryStateCity, setCountryStateCity] = useState({
        country: projectDetails?.participants?.country,
        state: projectDetails?.participants?.state,
        city: projectDetails?.participants?.city,
    });


    const calculatedGroups =
        isFGD && numParticipants && perGroup && Number(perGroup) > 0
            ? Math.ceil(Number(numParticipants) / Number(perGroup))
            : projectDetails?.participants?.numberOfGroups ?? 0;

    const { save, isSaving, saveError, saveSuccess } = useProjectUpdate(organizationID, projectID);

    const handleSave = () =>
        save({
            participants: {
                numberOfParticipants: numParticipants !== "" ? Number(numParticipants) : 0,
                participantsPerGroup: isFGD && perGroup !== "" ? Number(perGroup) : null,
                country: countryStateCity?.country || {},
                state: countryStateCity?.state || {},
                city: countryStateCity?.city || {},
            },
        });

    // countries :
    const {
        data: countriesData,
        isLoading: countriesDataLoading,
        error: countriesDataError,
    } = useQuery({
        queryFn: () => getCountries(),
        queryKey: ['all-countries'],
    });

    // states:
    const {
        data: statesData,
        isLoading: statesDataLoading,
        error: statesDataError,
    } =
        useQuery({
            queryFn: () => getStates({ country: countryStateCity?.country?.value }),
            enabled: Boolean(countryStateCity?.country?.value),
            queryKey: ['states-data', countryStateCity?.country?.value],
        });

    // cities:
    const {
        data: citiesData,
        isLoading: citiesDataLoading,
        error: citiesDataError,
    } =
        useQuery({
            queryFn: () => getCities({ country: countryStateCity?.country?.value, state: countryStateCity?.state?.value }),
            enabled: Boolean(countryStateCity?.country?.value && countryStateCity?.state?.value),
            queryKey: ['cities-data', countryStateCity?.country?.value, countryStateCity?.state?.value],
        })
    useEffect(() => {
        setNumParticipants(projectDetails?.participants?.numberOfParticipants ?? "");
        setPerGroup(projectDetails?.participants?.participantsPerGroup ?? "");
    }, [projectDetails]);

    // console.log({ countriesData, statesData, citiesData });
    // console.log(countryStateCity);


    return (
        <div className="space-y-6">
            <div className="flex justify-between items-start gap-4 bg-white p-4 rounded-xl ">
                <div className="space-y-[6px] w-full">
                    <div className='flex items-center justify-between'>
                        <label>Country<span className="text-red-500">*</span></label>
                        {countriesDataLoading && <Spinner size='xs' />}
                    </div>
                    <div
                        className={`rounded-lg`}
                    >
                        <select
                            className="border border-gray-300 rounded-md py-2.5 px-[14px] text-[#667085] text-[14px]
                                                             focus:outline-none focus:ring-1 focus:ring-[#0226BE] transition-all appearance-none
                                                             cursor-pointer hover:border-gray-400 bg-white w-full disabled:bg-gray-50 disabled:cursor-not-allowed"
                            style={SELECT_STYLE}
                            value={countryStateCity?.country?.value ?? ""}
                            onChange={(e) =>
                                setCountryStateCity(
                                    {
                                        ...countryStateCity,
                                        country: {
                                            value: e.target.value,
                                            label: e.target.options[e.target.selectedIndex].text
                                        }
                                    }
                                )}
                            disabled={!isEditable || countriesDataLoading || countriesDataError}
                        >
                            <option value="">Select the country</option>
                            {countriesData?.map((o) => (
                                <option key={o.value} value={o.value}>{o.label}</option>
                            ))}
                        </select>

                    </div>
                </div>
                <div className="space-y-[6px] w-full">
                    <div className='flex items-center justify-between'>
                        <label>State<span className="text-red-500">*</span></label>
                        {statesDataLoading && <Spinner size='xs' />}
                    </div>
                    <div>
                        <select
                            className="border border-gray-300 rounded-md py-2.5 px-[14px] text-[#667085] text-[14px]
                                                             focus:outline-none focus:ring-1 focus:ring-[#0226BE] transition-all appearance-none
                                                             cursor-pointer hover:border-gray-400 bg-white w-full disabled:bg-gray-50 disabled:cursor-not-allowed"
                            style={SELECT_STYLE}
                            value={countryStateCity?.state?.value ?? ""}
                            onChange={(e) =>
                                setCountryStateCity({
                                    ...countryStateCity,
                                    state: {
                                        value: e.target.value,
                                        label: e.target.options[e.target.selectedIndex].text
                                    }
                                })}
                            disabled={!isEditable || statesDataLoading || statesDataError || !countryStateCity?.country?.value}

                        >
                            <option value="">Select the state</option>
                            {statesData?.map((o) => (
                                <option key={o.value} value={o.value}>{o.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="space-y-[6px] w-full">
                    <div className='flex items-center justify-between'>
                        <label>City<span className="text-red-500">*</span></label>
                        {citiesDataLoading && <Spinner size='xs' />}
                    </div>
                    <div>
                        <select
                            className="border border-gray-300 rounded-md py-2.5 px-[14px] text-[#667085] text-[14px]
                                                             focus:outline-none focus:ring-1 focus:ring-[#0226BE] transition-all appearance-none
                                                             cursor-pointer hover:border-gray-400 bg-white w-full disabled:bg-gray-50 disabled:cursor-not-allowed"
                            style={SELECT_STYLE}
                            value={countryStateCity?.city?.value ?? ""}
                            onChange={(e) =>
                                setCountryStateCity(
                                    {
                                        ...countryStateCity,
                                        city: {
                                            value: e.target.value,
                                            label: e.target.options[e.target.selectedIndex].text
                                        }
                                    })
                            }
                            disabled={!isEditable || citiesDataLoading || citiesDataError || !countryStateCity?.country?.value || !countryStateCity?.state?.value}
                        >
                            <option value="">Select the city</option>
                            {citiesData?.map((o) => (
                                <option key={o?.value} value={o?.value}>{o?.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <div className="space-y-3 bg-white p-3 rounded-md">
                <h1 className="font-bold text-md">Participant Count</h1>

                {/* Number of participants */}
                <div className="space-y-2">
                    <p className="text-gray-600 text-sm font-medium">
                        Number of Participants <span className="text-red-500">*</span>
                    </p>
                    <div className="border rounded-lg px-[14px] py-2.5 flex items-center gap-2 bg-white">
                        <input
                            type="number"
                            className="w-full text-sm placeholder:text-sm focus:outline-none bg-transparent
                                disabled:text-gray-500 disabled:cursor-not-allowed"
                            placeholder="e.g. 20"
                            min={1}
                            value={numParticipants}
                            onChange={(e) => isEditable && setNumParticipants(e.target.value)}
                            disabled={!isEditable}
                            name="numberOfParticipants"
                        />
                        <RiPencilLine size={16} className="text-gray-300 flex-shrink-0" />
                    </div>
                </div>

                {/* Participants per group — FGD only */}
                {isFGD && (
                    <div className="space-y-2">
                        <p className="text-gray-600 text-sm font-medium">
                            Participants Per Group <span className="text-red-500">*</span>
                        </p>
                        <div className="border rounded-lg px-[14px] py-2.5 flex items-center gap-2 bg-white">
                            <input
                                type="number"
                                className="w-full text-sm placeholder:text-sm focus:outline-none bg-transparent
                                    disabled:text-gray-500 disabled:cursor-not-allowed"
                                placeholder="e.g. 6"
                                min={2}
                                max={12}
                                value={perGroup}
                                onChange={(e) => isEditable && setPerGroup(e.target.value)}
                                disabled={!isEditable}
                                name="participantsPerGroup"
                            />
                            <RiPencilLine size={16} className="text-gray-300 flex-shrink-0" />
                        </div>
                        <p className="text-gray-400 text-xs">Minimum 2, maximum 12 per group.</p>
                    </div>
                )}

                {/* Calculated groups — FGD only */}
                {isFGD && (
                    <div className="border border-primary p-3 bg-primary/10 rounded-xl">
                        <h3 className="text-xs font-[400] text-gray-600">Calculated Number of Groups:</h3>
                        <b className="text-sm text-[#0226BE]">
                            {numParticipants || 0} participants ÷ {perGroup || 0} per group ={" "}
                            <span className="text-base">{calculatedGroups}</span>{" "}
                            {calculatedGroups === 1 ? "focus group" : "focus groups"}
                        </b>
                    </div>
                )}

                {/* IDI: simple count display */}
                {!isFGD && numParticipants && (
                    <div className="border border-gray-100 p-3 bg-gray-50 rounded-xl">
                        <p className="text-xs text-gray-500">
                            {numParticipants} individual participant{numParticipants !== 1 ? "s" : ""} scheduled.
                        </p>
                    </div>
                )}


            </div>

            {isEditable && (
                <SaveBar
                    onSave={handleSave}
                    isSaving={isSaving}
                    saveSuccess={saveSuccess}
                    saveError={saveError}
                />
            )}
        </div>
    );
}